import images from './images';
import socials from './socials';

export const SECTIONS = ['home', 'about', 'work', 'skills', 'contact'];

// what the intro tunnel zooms through after the hero, one word per ~screen of scrolling
export const WARP_WORDS = ['I build', 'AI agents', '& RAG apps', 'that ship.'];

export { images, socials };
